<template>
  <div v-if="distributions && formater">
    <v-sheet class="hidden-print" style="margin-top: 80px" />
    <MutiplePiecesPrint
      :showSinglePrint="true"
      :formater="formater"
      :datas="distributions"
    />
  </div>
</template>
<script>
import StockOuts from "@/api/stock_outs";
import PrintTemplates from "@/api/print_templates";
import MutiplePiecesPrint from "@/components/plugins/print/MutiplePiecesPrint";
import makeData from "../distributions/makeData";

export default {
  components: {
    MutiplePiecesPrint,
  },

  data: () => ({
    formater: null,
    distributions: [],
  }),

  mounted() {
    PrintTemplates.fetchOne("distribution").then(
      function (response) {
        if (response.data.status.isOK()) {
          var formater = response.data.print_template.template;
          // formater.page_header_left = [];
          // formater.headers = [];
          // formater.title = null;
          // formater.settings.table_head_repetitive = false;
          // formater.settings.hide_page_counter = true;
          // formater.expand_columns = formater.expand_columns_bak; //.splice(0, 1);
          // formater.group_column = formater.group_column_bak;
          // formater.group_sum_columns = formater.group_sum_columns_bak; //.splice(0, 1);
          // formater.columns = formater.columns.splice(0, 7);
          // formater.sum_columns = [];
          this.formater = formater;
          //获取单据详情
          StockOuts.distributionsPrint(this.$route.query).then(
            function (response) {
              if (response.data.status.isOK()) {
                var distributions = [];
                response.data.stock_outs.forEach((stock_out) => {
                  if (stock_out.distribution) {
                    stock_out.order.shop = this.$printUtils.addCitiesName(
                      stock_out.order.shop
                    );
                    distributions.push({
                      order: stock_out.order,
                      distribution: Object.assign(
                        {},
                        stock_out,
                        makeData.processDetails(stock_out.distribution)
                      ),
                      order_address: stock_out.order_address,
                      print_date: new Date().toISOString().substr(0, 10),
                    });
                  }
                });
                this.distributions = distributions;
              }
            }.bind(this)
          );
        }
      }.bind(this)
    );
  },
};
</script>